export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST';
export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_SUCCESS = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_SUCCESS';
export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_FAILURE = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_FAILURE';
export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST';
export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_SUCCESS = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_SUCCESS';
export const GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_FAILURE = 'GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_FAILURE';


export const INSTALLER_SEARCH_REQUEST = 'INSTALLER_SEARCH_REQUEST';
export const INSTALLER_SEARCH_SUCCESS = 'INSTALLER_SEARCH_SUCCESS';
export const INSTALLER_SEARCH_FAILURE = 'INSTALLER_SEARCH_FAILURE';

export const ASSIGN_TOKENS_TO_INSTALLER_REQUEST = 'ASSIGN_TOKENS_TO_INSTALLER_REQUEST';
export const ASSIGN_TOKENS_TO_INSTALLER_SUCCESS = 'ASSIGN_TOKENS_TO_INSTALLER_SUCCESS';
export const ASSIGN_TOKENS_TO_INSTALLER_FAILURE = 'ASSIGN_TOKENS_TO_INSTALLER_FAILURE';

export const ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST = 'ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST';
export const ASSIGN_TOKENS_TO_DISTRIBUTOR_SUCCESS = 'ASSIGN_TOKENS_TO_DISTRIBUTOR_SUCCESS';
export const ASSIGN_TOKENS_TO_DISTRIBUTOR_FAILURE = 'ASSIGN_TOKENS_TO_DISTRIBUTOR_FAILURE';

export const RESET_INSTALLER_SEARCH = 'RESET_DEALER_SEARCH';

export const GET_STORE_URL_REQUEST = 'GET_STORE_URL_REQUEST';
export const GET_STORE_URL_SUCCESS = 'GET_STORE_URL_SUCCESS';
export const GET_STORE_URL_FAILURE = 'GET_STORE_URL_FAILURE';

export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const SEARCH_OBJ = {
  gen_token: { text: '', order_by: '' },
  purchase_dt: { text: '', order_by: '' },
  assigned_to: {text: '', order_by: ''},
  status: {text: '', order_by: ''}
};
